import ReferenceApi from "../api/ReferenceApi";

export default {
    namespaced: true,
    state:{
        reference: {}
    },
    mutations:{
        setReference(state, reference) {
            state.reference = reference;
        }
    },
    actions: {
        referenceAllAction({commit}){
            ReferenceApi.referenceAll()
                .then(res => {
                    commit('setReference',res.data)
                })
        }
    }
}
